import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ProgramService } from '../../../../core/services/program.service';
import { AppErrorShow } from '../../../../core/utils/app-error-show';
import { GlobalName } from '../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../core/utils/local-stoarge-service';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { SimpleCalendarComponent } from '../../../components/simple-calendar/simple-calendar.component';

@Component({
    selector: 'app-time-table',
    templateUrl: './time-table.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, SimpleCalendarComponent],
    styleUrls: ['./time-table.component.css']
})
export class TimeTableComponent {
  data:any[] =[]
  tag="professors-timetables"
  timeChosen=1
  user:any
  
  constructor(
    private programService:ProgramService,
    private spinnerService:NgxSpinnerService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }
  
    ngOnInit(){
      this.user=this.lsService.get(GlobalName.userName)

      this.getAll2()
    }
  

    reloadCalendar(ev:any,index:any){
      this.timeChosen=index
      if (this.timeChosen==1) {
        this.getAll()
      } else {
        this.getAll2()

      }
    
    }

    getAll2(){
      this.spinnerService.show()
      this.programService.getProfessorCurrentWeekPrograms(this.user?.professor?.pacs[0]?.classroom_id).subscribe((res:any)=>{
        this.data=res.data
        this.spinnerService.hide()

        console.log( this.data)
      },
      (err:any)=>{
        this.spinnerService.hide()

        AppErrorShow.showError("Emploi du temps",err)

      })
    }
     
  
    getAll(){
      this.spinnerService.show()
      this.programService.getProfessorCurrentWeekPrograms().subscribe((res:any)=>{
        this.data=res.data
        this.spinnerService.hide()

        console.log( this.data)
      },
      (err:any)=>{
        this.spinnerService.hide()

        AppErrorShow.showError("Emploi du temps",err)

      })
}
}